import { render, staticRenderFns } from "./AlertasLista.vue?vue&type=template&id=4079ec3f&"
import script from "./AlertasLista.vue?vue&type=script&lang=js&"
export * from "./AlertasLista.vue?vue&type=script&lang=js&"
import style0 from "./AlertasLista.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports